module.exports = __webpack_public_path__ + "img/fileText.078adc5a.svg";